import { latestItems } from '@/mocks/homeNews';
import SectionHeading from './SectionHeading';

export default function LatestGrid() {
  return (
    <section id="latest" className="w-full bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <SectionHeading
          kicker="Latest Updates"
          title="黑料新进展"
          desc="按小时滚动的新进展合集，只保留有新回应、有新证据或商业动向发生变化的条目。"
          action={
            <div className="flex items-center gap-1 bg-background-100 border border-background-200 rounded-md p-1 w-fit">
              <button
                type="button"
                className="px-3 py-1.5 text-[12px] rounded-full bg-primary-600 text-background-50 font-medium whitespace-nowrap"
              >
                最新
              </button>
              <button
                type="button"
                className="px-3 py-1.5 text-[12px] rounded-full text-foreground-600 hover:bg-background-200 whitespace-nowrap"
              >
                热议
              </button>
              <button
                type="button"
                className="px-3 py-1.5 text-[12px] rounded-full text-foreground-600 hover:bg-background-200 whitespace-nowrap"
              >
                反转
              </button>
            </div>
          }
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestItems.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden"
            >
              <div className="relative w-full h-[180px] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.category} 最新进展`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute bottom-3 left-3 inline-flex items-center bg-background-50/90 text-foreground-900 text-[11px] font-medium px-2.5 py-1 rounded-full backdrop-blur">
                  {item.category}
                </span>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="text-[15px] font-semibold leading-snug text-foreground-950 line-clamp-2">
                  {item.title}
                </h3>
                <div className="mt-4 pt-3 border-t border-background-200 flex items-center justify-between text-[12px] text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-fire-line text-[13px] text-primary-600" />
                    </span>
                    {item.heat}
                  </span>
                  <span>{item.time}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}